module.exports = __webpack_public_path__ + "static/jk-rowling-aabf6079279bef7902ad60b36819b842.jpg";